module.exports = __webpack_public_path__ + "img/NO937901925.8521ddc4.png";